(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5048,4006],{

/***/ 1681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Request; }
});

// EXTERNAL MODULE: ./styles/contact.module.scss
var contact_module = __webpack_require__(451);
var contact_module_default = /*#__PURE__*/__webpack_require__.n(contact_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./src/components/Shared/BreadCrumbs.js
var BreadCrumbs = __webpack_require__(5467);
// EXTERNAL MODULE: ./src/components/Shared/Next-seo.js
var Next_seo = __webpack_require__(6543);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react-range/lib/index.js
var lib = __webpack_require__(4398);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(6455);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./src/components/Home/request/styles/style.module.scss
var style_module = __webpack_require__(4175);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/api/server.js + 54 modules
var server = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/components/helpers/functions.js
var functions = __webpack_require__(7819);
// EXTERNAL MODULE: ./src/assets/images/svg/sar.svg
var sar = __webpack_require__(5175);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./src/assets/images/svg/download.svg
var download = __webpack_require__(1476);
// EXTERNAL MODULE: ./src/assets/images/svg/expand.svg
var expand = __webpack_require__(7571);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/request/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var RequestSection = function RequestSection(_ref) {
  var countries = _ref.countries;

  var _useIntl = (0,useIntl/* default */.Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      allPersonnels = _useState3[0],
      setAllPersonnels = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      filteredPersonnels = _useState4[0],
      setFilteredPersonnels = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      selectedCountry = _useState5[0],
      setSelectedCountry = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      selectedReligion = _useState6[0],
      setSelectedReligion = _useState6[1];

  var _useState7 = (0,react.useState)([100]),
      ageRange = _useState7[0],
      setAgeRange = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      selectedServantId = _useState8[0],
      setSelectedServantId = _useState8[1];

  var _useState9 = (0,react.useState)(null),
      swiperRef = _useState9[0],
      setSwiperRef = _useState9[1];

  var _useState10 = (0,react.useState)(""),
      expandedImage = _useState10[0],
      setExpandedImage = _useState10[1];

  var religions = (0,react.useMemo)(function () {
    return [{
      value: "muslim",
      label: {
        ar: "مسلم",
        en: "Muslim"
      }
    }, {
      value: "christian",
      label: {
        ar: "مسيحي",
        en: "Christian"
      }
    }, {
      value: "jewish",
      label: {
        ar: "يهودي",
        en: "Jewish"
      }
    }];
  }, []);

  var getLocalizedValue = function getLocalizedValue(field) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";

    if (typeof field === "object" && field !== null) {
      return (field === null || field === void 0 ? void 0 : field[locale]) || (field === null || field === void 0 ? void 0 : field.ar) || (field === null || field === void 0 ? void 0 : field.en) || fallback;
    }

    if (typeof field === "string") {
      return field || fallback;
    }

    return fallback;
  };

  var getNormalizedReligion = function getNormalizedReligion(religionField) {
    var value = getLocalizedValue(religionField, "").toString().toLowerCase();

    if (value.includes("islam") || value.includes("muslim") || value.includes("اسلام") || value.includes("مسلم")) {
      return "muslim";
    }

    if (value.includes("christ") || value.includes("مسيح") || value.includes("نصر")) {
      return "christian";
    }

    if (value.includes("jew") || value.includes("يهود") || value.includes("juda")) {
      return "jewish";
    }

    return "";
  };

  var selectedServant = (0,react.useMemo)(function () {
    return filteredPersonnels.find(function (item) {
      return "".concat(item === null || item === void 0 ? void 0 : item.id) === "".concat(selectedServantId);
    }) || allPersonnels.find(function (item) {
      return "".concat(item === null || item === void 0 ? void 0 : item.id) === "".concat(selectedServantId);
    }) || null;
  }, [filteredPersonnels, allPersonnels, selectedServantId]);
  (0,react.useEffect)(function () {
    var fetchPersonnels = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _personnelsRes$data, _personnelsRes$data$d, personnelsRes, personnels, availablePersonnels;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return server/* default.get */.Z.get("/personnels");

              case 4:
                personnelsRes = _context.sent;
                personnels = (personnelsRes === null || personnelsRes === void 0 ? void 0 : (_personnelsRes$data = personnelsRes.data) === null || _personnelsRes$data === void 0 ? void 0 : (_personnelsRes$data$d = _personnelsRes$data.data) === null || _personnelsRes$data$d === void 0 ? void 0 : _personnelsRes$data$d.personnels) || [];
                availablePersonnels = personnels.filter(function (item) {
                  return item === null || item === void 0 ? void 0 : item.available;
                });
                setAllPersonnels(availablePersonnels);
                setFilteredPersonnels(availablePersonnels);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                setAllPersonnels([]);
                setFilteredPersonnels([]);

              case 15:
                _context.prev = 15;
                setLoading(false);
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11, 15, 18]]);
      }));

      return function fetchPersonnels() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchPersonnels();
  }, []);

  var handleSearch = function handleSearch() {
    var result = allPersonnels.filter(function (item) {
      var _item$country;

      var matchesCountry = !selectedCountry || "".concat(item === null || item === void 0 ? void 0 : (_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.id) === "".concat(selectedCountry);
      var matchesReligion = !selectedReligion || getNormalizedReligion(item === null || item === void 0 ? void 0 : item.religion) === selectedReligion;
      var itemAge = Number(item === null || item === void 0 ? void 0 : item.age) || 0;
      var matchesAge = itemAge >= 18 && itemAge <= ageRange[0];
      return matchesCountry && matchesReligion && matchesAge;
    });
    setFilteredPersonnels(result);

    if (selectedServantId && !result.find(function (item) {
      return "".concat(item === null || item === void 0 ? void 0 : item.id) === "".concat(selectedServantId);
    })) {
      setSelectedServantId(null);
    }
  };

  var buildMessage = function buildMessage(person) {
    var _person$name, _person$name2, _person$country, _person$name3;

    return "\u0627\u0633\u0645 \u0627\u0644\u062E\u0627\u062F\u0645\u0629: ".concat((person === null || person === void 0 ? void 0 : (_person$name = person.name) === null || _person$name === void 0 ? void 0 : _person$name.ar) || (person === null || person === void 0 ? void 0 : (_person$name2 = person.name) === null || _person$name2 === void 0 ? void 0 : _person$name2[locale]) || "-", "\n\u0627\u0644\u062F\u064A\u0627\u0646\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.religion), "\n\u0643\u0648\u062F \u0627\u0644\u062E\u0627\u062F\u0645\u0629: ").concat((person === null || person === void 0 ? void 0 : person.id) || "-", "\n\u0627\u0644\u062F\u0648\u0644\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : (_person$country = person.country) === null || _person$country === void 0 ? void 0 : _person$country.name), "\n\u0627\u0644\u0639\u0645\u0631: ").concat((person === null || person === void 0 ? void 0 : person.age) || "-", "\n\u0627\u0644\u0644\u063A\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.experience), "\n\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u062E\u0628\u0631\u0629: ").concat((person === null || person === void 0 ? void 0 : (_person$name3 = person.name) === null || _person$name3 === void 0 ? void 0 : _person$name3.experienceYears) || "-", "\n\u0631\u0633\u0648\u0645 \u0627\u0644\u0627\u0633\u062A\u0642\u062F\u0627\u0645: ").concat((person === null || person === void 0 ? void 0 : person.recruitmentFees) || "-");
  };

  var handlePdfDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(item) {
      var _item$name, _item$name2;

      var pdfUrl, response, blob, link;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              pdfUrl = item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.file;
              _context2.next = 3;
              return fetch(pdfUrl);

            case 3:
              response = _context2.sent;
              _context2.next = 6;
              return response.blob();

            case 6:
              blob = _context2.sent;
              link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "".concat(item === null || item === void 0 ? void 0 : (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.ar, ".pdf");
              link.click();
              window.URL.revokeObjectURL(link.href);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handlePdfDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleExpandImage = function handleExpandImage(item) {
    var _item$name3;

    var imageUrl = (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name3 = item.name) === null || _item$name3 === void 0 ? void 0 : _item$name3.pdfImage);
    if (!imageUrl) return;
    setExpandedImage(imageUrl);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(data) {
      var payload;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (selectedServant) {
                _context3.next = 3;
                break;
              }

              sweetalert2_all_default().fire("", locale === "ar" ? "اختر العاملة أولاً" : "Please select a servant first", "warning");
              return _context3.abrupt("return");

            case 3:
              payload = {
                name: data === null || data === void 0 ? void 0 : data.name,
                phone: data === null || data === void 0 ? void 0 : data.phone,
                email: data === null || data === void 0 ? void 0 : data.email,
                message: buildMessage(selectedServant)
              };
              _context3.prev = 4;
              setSubmitting(true);
              _context3.next = 8;
              return server/* default.post */.Z.post("/requests", payload);

            case 8:
              reset();
              setSelectedServantId(null);
              sweetalert2_all_default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](4);
              sweetalert2_all_default().fire("", locale === "ar" ? "حدث خطأ أثناء الإرسال" : "Failed to submit request", "error");

            case 16:
              _context3.prev = 16;
              setSubmitting(false);
              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 13, 16, 19]]);
    }));

    return function onSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (style_module_default()).request,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("form", {
      onSubmit: handleSubmit(onSubmit),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "form-group",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: "name",
              children: formatMessage({
                id: "name"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
              id: "name",
              className: "form-control"
            }, register("name", {
              required: true
            }))), (errors === null || errors === void 0 ? void 0 : errors.name) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "error-hint",
              children: formatMessage({
                id: "requiredField"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "form-group",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: "phone",
              children: formatMessage({
                id: "phone"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
              id: "phone",
              className: "form-control",
              maxLength: 14
            }, register("phone", {
              required: true,
              pattern: /^[0-9+]+$/
            }))), (errors === null || errors === void 0 ? void 0 : errors.phone) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "error-hint",
              children: formatMessage({
                id: "requiredField"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "form-group",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: "email",
              children: formatMessage({
                id: "email"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
              id: "email",
              type: "email",
              className: "form-control"
            }, register("email", {
              required: true
            }))), (errors === null || errors === void 0 ? void 0 : errors.email) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "error-hint",
              children: formatMessage({
                id: "requiredField"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "personnels",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                lg: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "form-group",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "country",
                    children: formatMessage({
                      id: "country"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
                    id: "country",
                    className: "form-control form-select",
                    value: selectedCountry,
                    onChange: function onChange(event) {
                      return setSelectedCountry(event.target.value);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "",
                      children: locale === "ar" ? "الكل" : "All"
                    }), countries === null || countries === void 0 ? void 0 : countries.map(function (country) {
                      var _country$name, _country$name2, _country$name3;

                      return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                        value: country === null || country === void 0 ? void 0 : country.id,
                        children: (country === null || country === void 0 ? void 0 : (_country$name = country.name) === null || _country$name === void 0 ? void 0 : _country$name[locale]) || (country === null || country === void 0 ? void 0 : (_country$name2 = country.name) === null || _country$name2 === void 0 ? void 0 : _country$name2.ar) || (country === null || country === void 0 ? void 0 : (_country$name3 = country.name) === null || _country$name3 === void 0 ? void 0 : _country$name3.en)
                      }, country === null || country === void 0 ? void 0 : country.id);
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                lg: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "form-group",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "religion",
                    children: formatMessage({
                      id: "religion"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
                    id: "religion",
                    className: "form-control form-select",
                    value: selectedReligion,
                    onChange: function onChange(event) {
                      return setSelectedReligion(event.target.value);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "",
                      children: locale === "ar" ? "الكل" : "All"
                    }), religions.map(function (religion) {
                      var _religion$label, _religion$label2;

                      return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                        value: religion.value,
                        children: (religion === null || religion === void 0 ? void 0 : (_religion$label = religion.label) === null || _religion$label === void 0 ? void 0 : _religion$label[locale]) || (religion === null || religion === void 0 ? void 0 : (_religion$label2 = religion.label) === null || _religion$label2 === void 0 ? void 0 : _religion$label2.ar)
                      }, religion.value);
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                lg: 12,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "form-group",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "ageRange",
                    children: formatMessage({
                      id: "ageRange"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib.Range, {
                    values: ageRange,
                    step: 1,
                    min: 18,
                    max: 100,
                    onChange: function onChange(values) {
                      return setAgeRange(values);
                    },
                    rtl: locale === "ar" ? true : false,
                    renderTrack: function renderTrack(_ref5) {
                      var props = _ref5.props,
                          children = _ref5.children;
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "trackWrap",
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          ref: props.ref,
                          className: (style_module_default()).track,
                          rtl: locale === "ar" ? true : false,
                          style: {
                            height: "6px",
                            width: "100%",
                            borderRadius: "5px",
                            background: (0,lib.getTrackBackground)({
                              values: ageRange,
                              colors: ["#6c3d8e", "#ccc"],
                              min: 18,
                              max: 100,
                              rtl: locale === "ar" ? true : false
                            }),
                            alignSelf: "center"
                          },
                          children: children
                        })
                      });
                    },
                    renderThumb: function renderThumb(_ref6) {
                      var props = _ref6.props,
                          isDragged = _ref6.isDragged;
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
                        className: "thumb"
                      }, props), {}, {
                        style: _objectSpread({}, props.style),
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "thumbInner",
                          style: {
                            backgroundColor: isDragged ? "#6c3d8e" : "#fff"
                          }
                        })
                      }));
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "ageRangeValues d-flex align-items-center justify-content-between mt-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["18 ", formatMessage({
                        id: "year"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: [ageRange[0], " ", formatMessage({
                        id: "year"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["100 ", formatMessage({
                        id: "year"
                      })]
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                lg: 12,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "form-group",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "btn nw-btn search-btn",
                    onClick: handleSearch,
                    children: locale === "ar" ? "بحث" : "Search"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                lg: 12,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "form-group",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).cardsWrap,
                    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: (style_module_default()).emptyText,
                      children: locale === "ar" ? "جاري التحميل..." : "Loading..."
                    }) : filteredPersonnels.length === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: (style_module_default()).emptyText,
                      children: formatMessage({
                        id: "noPersonnels"
                      })
                    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl],
                        onSwiper: setSwiperRef,
                        slidesPerView: 1,
                        spaceBetween: 16,
                        breakpoints: {
                          768: {
                            slidesPerView: 2
                          },
                          1024: {
                            slidesPerView: 3
                          }
                        },
                        pagination: {
                          dynamicBullets: true,
                          clickable: true
                        },
                        navigation: {
                          nextEl: ".navigationButtons .next",
                          prevEl: ".navigationButtons .prev"
                        },
                        children: filteredPersonnels.map(function (item) {
                          var _item$name4, _item$name5, _item$country2, _item$country2$name, _item$religion, _item$name6, _item$job;

                          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: selectedServantId === (item === null || item === void 0 ? void 0 : item.id) ? "personnel active" : "personnel",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "img",
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                  src: (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name4 = item.name) === null || _item$name4 === void 0 ? void 0 : _item$name4.pdfImage),
                                  alt: "",
                                  width: 500,
                                  height: 500
                                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                                  type: "button",
                                  className: "pdf-btn",
                                  onClick: function onClick() {
                                    return handlePdfDownload(item);
                                  },
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                    src: download/* default */.Z,
                                    alt: "",
                                    width: 16,
                                    height: 16
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "downloadPdf"
                                  })]
                                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                                  type: "button",
                                  className: "expand-btn",
                                  onClick: function onClick() {
                                    return handleExpandImage(item);
                                  },
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                    src: expand/* default */.Z,
                                    alt: "",
                                    width: 16,
                                    height: 16
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "expandImage"
                                  })]
                                })]
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "info",
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                                    href: "/personnel/".concat(item === null || item === void 0 ? void 0 : item.id),
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                      className: "details-link nw-btn",
                                      children: item === null || item === void 0 ? void 0 : (_item$name5 = item.name) === null || _item$name5 === void 0 ? void 0 : _item$name5[locale]
                                    })
                                  })
                                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "nationality"
                                      }), ":", " "]
                                    }), item === null || item === void 0 ? void 0 : (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : (_item$country2$name = _item$country2.name) === null || _item$country2$name === void 0 ? void 0 : _item$country2$name[locale]]
                                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "code"
                                      }), ":"]
                                    }), item === null || item === void 0 ? void 0 : item.id]
                                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "religion"
                                      }), ":", " "]
                                    }), item === null || item === void 0 ? void 0 : (_item$religion = item.religion) === null || _item$religion === void 0 ? void 0 : _item$religion[locale]]
                                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "experienceYears"
                                      }), ":", " "]
                                    }), item === null || item === void 0 ? void 0 : (_item$name6 = item.name) === null || _item$name6 === void 0 ? void 0 : _item$name6.experienceYears]
                                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "age"
                                      }), ":"]
                                    }), item === null || item === void 0 ? void 0 : item.age, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                      id: "year"
                                    })]
                                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "job"
                                      }), ":"]
                                    }), item === null || item === void 0 ? void 0 : (_item$job = item.job) === null || _item$job === void 0 ? void 0 : _item$job[locale]]
                                  }), (item === null || item === void 0 ? void 0 : item.salary) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "monthlySalary"
                                      }), ":"]
                                    }), " ", item === null || item === void 0 ? void 0 : item.salary, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                      src: sar/* default */.Z,
                                      alt: "",
                                      width: 18,
                                      height: 18,
                                      className: "mx-1"
                                    })]
                                  }), (item === null || item === void 0 ? void 0 : item.recruitmentFees) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                                      className: "key",
                                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "recruitmentFees"
                                      }), ":"]
                                    }), " ", item === null || item === void 0 ? void 0 : item.recruitmentFees, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                      src: sar/* default */.Z,
                                      alt: "",
                                      width: 18,
                                      height: 18,
                                      className: "mx-1"
                                    })]
                                  })]
                                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: "btns d-flex align-items-center justify-content-between gap-3",
                                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "open-request-modal nw-btn",
                                    onClick: function onClick() {
                                      return setSelectedServantId(item === null || item === void 0 ? void 0 : item.id);
                                    },
                                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                                      id: "selectServant"
                                    })
                                  })
                                })]
                              })]
                            })
                          }, item === null || item === void 0 ? void 0 : item.id);
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "navigationButtons d-flex align-items-center justify-content-center gap-3 mt-4",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                          type: "button",
                          className: "prev",
                          children: locale === "ar" ? "‹" : "‹"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                          type: "button",
                          className: "next",
                          children: locale === "ar" ? "›" : "›"
                        })]
                      })]
                    })
                  })
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "form-group",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "submit",
              className: "btn nw-btn submit-btn",
              disabled: submitting,
              children: submitting ? locale === "ar" ? "جاري الإرسال..." : "Submitting..." : formatMessage({
                id: "send"
              })
            })
          })
        })]
      })
    }), expandedImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "zoom-image",
      onClick: function onClick() {
        return setExpandedImage("");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: expandedImage,
        width: 1200,
        height: 1200,
        alt: ""
      })
    })]
  });
};

/* harmony default export */ var request = (RequestSection);
;// CONCATENATED MODULE: ./pages/recruitmentRequest.js









var __N_SSP = true;
function Request(_ref) {
  var _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords;

  var requestData = _ref.requestData,
      seoData = _ref.seoData;

  var _useIntl = (0,useIntl/* default */.Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useRouter = (0,router.useRouter)(),
      query = _useRouter.query;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) && /*#__PURE__*/(0,jsx_runtime.jsx)(Next_seo["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-page ".concat((contact_module_default()).contact),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs["default"], {
        heading: formatMessage({
          id: query !== null && query !== void 0 && query.personId ? "request" : "admissionRequest"
        }),
        description: "".concat(formatMessage({
          id: "main"
        }), " / ").concat(formatMessage({
          id: "request"
        })),
        background: requestData === null || requestData === void 0 ? void 0 : requestData.breadCurmbImage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(request, {
          countries: requestData === null || requestData === void 0 ? void 0 : requestData.items
        })
      })]
    })]
  });
}

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 7819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "SI": function() { return /* binding */ htmlToExcerpt; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports mapBlogForListing, checkRedirect */
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



var getId = function getId(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id) || "".concat(obj);
}; // يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة

var htmlToExcerpt = function htmlToExcerpt(html) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!html) return "";
  var withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  var text = withoutImages.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? "".concat(text.slice(0, maxLength).trim(), "\u2026") : text;
}; // يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير

var localizedExcerpt = function localizedExcerpt(localized, maxLength) {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(Object.entries(localized).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        html = _ref2[1];

    return [locale, htmlToExcerpt(html, maxLength)];
  }));
}; // يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)


var mapBlogForListing = function mapBlogForListing(blog) {
  var _blog$category, _blog$category2, _blog$category3;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    id: (blog === null || blog === void 0 ? void 0 : blog.id) || (blog === null || blog === void 0 ? void 0 : blog._id) || null,
    title: blog === null || blog === void 0 ? void 0 : blog.title,
    image: blog === null || blog === void 0 ? void 0 : blog.image,
    category: blog !== null && blog !== void 0 && blog.category ? {
      id: (blog === null || blog === void 0 ? void 0 : (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : _blog$category.id) || (blog === null || blog === void 0 ? void 0 : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : _blog$category2._id) || null,
      title: (blog === null || blog === void 0 ? void 0 : (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : _blog$category3.title) || null
    } : null,
    createdAt: blog === null || blog === void 0 ? void 0 : blog.createdAt,
    description: localizedExcerpt(blog === null || blog === void 0 ? void 0 : blog.description, maxLength)
  };
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    return "".concat("https://alnojoom.ejjadh.info/", "/").concat(image);
  }
}; // ضع هذا الكود داخل نفس ملف الصفحة

var REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects"; // نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار

function cleanPath() {
  var resolvedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    var noQuery = String(resolvedUrl).split("?")[0] || "/";
    var decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/") ? decoded.slice(0, -1) : decoded;
  } catch (_unused) {
    var _noQuery = String(resolvedUrl).split("?")[0] || "/";

    return _noQuery.length > 1 && _noQuery.endsWith("/") ? _noQuery.slice(0, -1) : _noQuery;
  }
} // ابنِ Destination مطلق بدون أي Query Params


function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      var u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }

    var protocol = (req.headers["x-forwarded-proto"] || "").split(",")[0] || (req.socket && req.socket.encrypted ? "https" : "http");
    var host = req.headers.host;
    var path = destRaw.startsWith("/") ? destRaw : "/".concat(destRaw);
    return "".concat(protocol, "://").concat(host).concat(path);
  } catch (_unused2) {
    return String(destRaw).split("?")[0];
  }
}

function checkRedirect(_x, _x2) {
  return _checkRedirect.apply(this, arguments);
}

function _checkRedirect() {
  _checkRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolvedUrl, req) {
    var path, res, json, redirects, hit, permanent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = cleanPath(resolvedUrl);
            _context.prev = 1;
            _context.next = 4;
            return fetch(REDIRECTS_ENDPOINT, {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            json = _context.sent;
            redirects = json && json.data && json.data.seoRedirects || [];
            hit = redirects.find(function (r) {
              return (r === null || r === void 0 ? void 0 : r.source) && (r === null || r === void 0 ? void 0 : r.destination) && cleanPath(r.source) === path;
            });

            if (hit) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            permanent = String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
            return _context.abrupt("return", {
              destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
              permanent: permanent
            });

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", null);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _checkRedirect.apply(this, arguments);
}

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 2992:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentRequest",
      function () {
        return __webpack_require__(1681);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download.b3e7badf.svg","height":20,"width":20});

/***/ }),

/***/ 7571:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/expand.83306eef.svg","height":16,"width":16});

/***/ }),

/***/ 5175:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/sar.f03e266e.svg","height":13,"width":12});

/***/ }),

/***/ 4175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"request":"style_request__3vuCx"};

/***/ }),

/***/ 451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact___aHw6","gradient_in":"contact_gradient_in__hWSdp","gradient_out":"contact_gradient_out__OA75o","gradient_opacity_out":"contact_gradient_opacity_out___ZqSU","gradient_opacity_in":"contact_gradient_opacity_in__JKerv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8166,2962,2143,1664,3053,5836,4398,9774,2888,179], function() { return __webpack_exec__(2992); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);